export default {
    "theatre": {
        "login": "",
        "register": "",
        "pay": "",
        "order": "/order/api/saveOrder",
        "lockStock": "/order/api/lockTtStock",
        "detailMain": "/merchant/api/theater/merchantTheaterShow",
        "theaterPlaceByCode": "/merchant/api/theater/merchantTheaterPlaceByCode",
        "placeByPlayDate": "/merchant/api/theater/getZybPlaceByPlayDate",
        "getShowArea": "/merchant/api/theater/getShowArea",
        "seats": "/merchant/api/theater/getSeat",
        "list": {
            "pagelist": "/merchant/api/theater/merchantTheaterShowGrid"
        }
    },
    "main": {
        "getMovieTownConfig":"/merchant/api/merchantFamilyInfo/getMovieTownConfig",
        "getMerchantInfo": "/merchant/api/merchantInfo/getMerchantInfo",
        "getUsePage": "/merchant/api/merchantRenovationToc/getUsePage",
        "huangshanadmin":"/merchant/api/merchantRenovationToc/getRenovationById",
        "indexbanner":"/merchant/api/merchantAdvManage/findPicInfo", //电影小镇首页轮播
        "indexgetContent":"/merchant/api/merchantFamilyInfo/getContent", //电影小镇首页轮播
        "selectServiceUse": "/marketing/api/market/selectServiceUse",
        "sysParam": {
            "changeList": "/admin/api/sysParam/changeList"
        },
        "address": {
            "list": "/leaguer/api/userLeaguerAddress/manage/leaguerAddressPage", //收货地址列表
            "detail": "/leaguer/api/userLeaguerAddress/manage/leaguerAddressInfo", //地址详情
            "delete": "/leaguer/api/userLeaguerAddress/manage/delLeaguerAddress", //删除
            "save": "/leaguer/api/userLeaguerAddress/manage/saveLeaguerAddress", //地址保存
            'default': '/leaguer/api/userLeaguerAddress/manage/setDefaultAddress' //设置默认地址
        },
    },
    "hotel": {
        "list": {
            "pagelist": "/merchant/api/merchantHotelInfo/merchantHotelInfoGrid",
            "newpagelist":"/merchant/api/pmsMerchantHotelInfo/listHotelInfo",
            "listHotelInfo":"/merchant/api/pmsMerchantHotelInfo/listHotelInfo"
        },
        "detail": {
            "main": "/merchant/api/merchantHotelInfo/merchantHotelInfo",
            "pmsmain": "/merchant/api/pmsMerchantHotelInfo/getHotelInfoDetail",
            "productItems": "/merchant/api/merchantHotelRoom/merchantHotelRoomGrid"
        },
        "order": {
            "main": "/merchant/api/merchantHotelRoom/merchantHotelRoom"
        }
    },
    "news":{ //资讯
        "getFirstTree": "/merchant/api/merchantFamilyInfo/getFirstTree", //获取列表id，根据id查列表
        "list": "/merchant/api/merchantFamilyInfo/getContent", //列表
        "detailInfo": "/merchant/api/merchantFamilyInfo/getContentById" //详情及上一篇下一篇
    },
    "ticket": {
        "list": {
            "pagelist": "/merchant/api/merchantParkInfo/merchantParkInfoGrid"
        },
        "detail": {
            "main": "/merchant/api/merchantParkInfo/merchantParkInfo",
            "isAppJump":"/pmsproduct/api/openData/qrCodeUrl",
            "productItems": "/merchant/api/merchantParkTicketGridNew",
            "getSaleStatusByModelCode": "/merchant/api/getSaleStatusByModelCode"
        }
    },
    "eatery": {
        "list": {
            "pagelist": "/merchant/api/merchantRepastEatery/merchantRepastEateryGrid"
        },
        "detail": {
            "main": "/merchant/api/merchantRepastEatery/getRepastEateryVoById",
            "mealCoupon": "/merchant/api/merchantRepastEatery/getRepastCouponVoById"
        }
    },
    "route": {
        "list": {
            "pagelist": "/merchant/api/merchantRouteInfo/merchantRouteInfoGrid"
        },
        "detail": {
            "main": "/merchant/api/merchantRouteInfo/getMerchantRouteInfoById",
            "listCalendarPriceMap": "/merchant/api/merchantRouteInfo/listCalendarPriceMap",
            "getRouteByMerchantParkInfoId": "/merchant/api/merchantRouteInfo/getRouteByMerchantParkInfoId"
        }
    },
    "allTickets": {
        "list": {
            "pagelist": "/merchant/api/merchantFamilyInfo/list"
        },
        "detail": {
            "main": "/merchant/api/merchantFamilyInfo/familyDetail",
            "familyTicketList": "/merchant/api/merchantFamilyInfo/familyTicketList",
            "getRouteByMerchantParkInfoId": "/merchant/api/merchantRouteInfo/getRouteByMerchantParkInfoId"
        }
    },
    "shop": {
        "list": {
            "pagelist": "/merchant/api/merchantMsdeInfo/listMerchantMsdeInfo" //商品列表
        },
        "detail": {
            "main": "/merchant/api/merchantMsdeInfo/getMerchantMsdeInfo", //商品详情
            "sku": "/merchant/api/merchantMsdeInfo/getMerchantMsdeSKu" //sku
        },
        "order": {
            "main": "/merchant/api/merchantMsdeInfo/getMerchantMsdeSKu",
            "listPoint": "/product/api/shop/listPoint",
            "address": "/merchant/api/merchantMsdeInfo/getArea",
            "getPostage": "/merchant/api/merchantMsdeInfo/getPostagePrice", //获取邮费
            "getStock": "/product/api/shop/getStock",
            "selfPlace": "/leaguer/api/order/manage/selfPlace"
        }
    },
    "comment": {
        "upData": "/merchant/api/merchantProdComments/doUpdateMerchantProdComments",
        "list": "/merchant/api/merchantProdComments/getCommentByPage",
        "add": "/merchant/api/merchantProdComments/saveMerchantProdComments",
        "iscomment": "/merchant/api/merchantProdComments/userIfEvaluate"
    },
}


// WEBPACK FOOTER //
// ./src/api/api.js